import React, { useContext } from 'react';
import PropTypes from 'prop-types';

import { useLogger } from './logger';
import { loggerPropTypesShape, defaultLogger } from './shape';

export const LoggerContext = React.createContext(defaultLogger);

export const useLoggerContext = () => useContext(LoggerContext);

export const LoggerContextProvider = ({
  children,
  logger,
  defaultScenarioName,
}) => {
  const loggerProviderValue = useLogger({
    defaultScenarioName,
    logging: logger,
  });
  return (
    <LoggerContext.Provider value={loggerProviderValue}>
      {children}
    </LoggerContext.Provider>
  );
};

LoggerContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
  logger: loggerPropTypesShape,
  defaultScenarioName: PropTypes.string,
};

LoggerContextProvider.defaultProps = {
  logger: defaultLogger,
  defaultScenarioName: '',
};
